/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListDoctorExtraSpecialtiesResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'DoctorExtraSpecialty',
        },
      },
    },
  }],
} as const;
